import moment from "moment";

export function centimesToCurrency(amount) {
  return (amount / 100).toFixed(2) + ' €';
}

/**
 * Date de récupération attendue par défaut : lendemain de la livraison,
 * reportée au lundi si le lendemain tombe un week-end.
 */
export const getExpectedRecoveryDate = (deliveryDate) => {
  if (!deliveryDate) return null;
  const expected = moment(deliveryDate).startOf("day").add(1, "day");
  const dayOfWeek = expected.day();
  if (dayOfWeek === 6) expected.add(2, "days");
  else if (dayOfWeek === 0) expected.add(1, "day");
  return expected;
};

/** true si la date de récupération diffère du lendemain attendu (week-end inclus). */
export const isUnusualRecoveryDate = (deliveryDate, recoveryDate) => {
  if (!deliveryDate || !recoveryDate) return false;
  const expected = getExpectedRecoveryDate(deliveryDate);
  return !moment(recoveryDate).startOf("day").isSame(expected, "day");
};

/**
 * Traduit en français le type de prestation en ajoutant une majuscule à la première lettre
 */
export function toFrenchType(type, shortcut = false) {
  let translatedType = type;
  if (type === 'mealtray') {
    translatedType = 'plateau repas';
    if(shortcut){
      translatedType = 'PR';
    }
  }
  if (type === 'breakfast') {
    translatedType = 'petit déjeuner';
    if(shortcut){
      translatedType = 'PDJ';
    }
  }
  if (type === 'caterer') {
    translatedType = 'cocktail';
    if(shortcut){
      translatedType = 'Ckt';
    }
  }
  translatedType = translatedType ? translatedType.charAt(0).toUpperCase() + translatedType.slice(1) : translatedType;
  return translatedType;
}
